import Vue from 'vue';

export default new Vue();



// WEBPACK FOOTER //
// ./boards/eventhub.js